module.exports = __webpack_public_path__ + "media/images/horses/horse-weight-calculator-1.jpg";